import React, { useRef, useState } from "react";
import "./ConfirmModal.css";

export function useConfirm() {
  const resolverRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    title: "확인",
    message: "",          // string 또는 JSX(ReactNode) 모두 허용
    danger: false,
    okText: "확인",
    cancelText: "취소",
  });

  const confirm = (opts = {}) =>
    new Promise((resolve) => {
      resolverRef.current = resolve;
      setState((s) => ({
        ...s,
        open: true,
        title: opts.title ?? "확인",
        message: opts.message ?? "",
        danger: !!opts.danger,
        okText: opts.okText ?? "확인",
        cancelText: opts.cancelText ?? "취소",
      }));
    });

  const closeWith = (val) => {
    if (resolverRef.current) {
      resolverRef.current(val);
      resolverRef.current = null;
    }
    setState((s) => ({ ...s, open: false }));
  };

  const onBackdrop = (e) => {
    if (e.target === e.currentTarget) closeWith(false);
  };

  const ConfirmDialog = !state.open ? null : (
    <div className="cmodal-backdrop" onClick={onBackdrop}>
      <div
        className={`cmodal-panel${state.danger ? " danger" : ""}`}
        role="dialog"
        aria-modal="true"
      >
        <header className="cmodal-head">
          <h3>{state.title}</h3>
        </header>

        <div className="cmodal-body">
          {
            // 문자열이면 \n 줄바꿈 지원, JSX면 그대로 렌더
            typeof state.message === "string"
              ? <p style={{ whiteSpace: "pre-line", margin: 0 }}>{state.message}</p>
              : state.message
          }
        </div>

        <footer className="cmodal-foot">
          <button className="cbtn outline" onClick={() => closeWith(false)} autoFocus>
            {state.cancelText}
          </button>
          <button
            className={`cbtn primary${state.danger ? " danger" : ""}`}
            onClick={() => closeWith(true)}
          >
            {state.okText}
          </button>
        </footer>
      </div>
    </div>
  );

  return { confirm, ConfirmDialog };
}
